import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for C5M2 (S/C Writeoff)
// ============================================================

export interface WriteoffItem {
  fc110_01: string;    // S/C No
  fc110_12: string;    // Customer name (F104 lookup)
  fc110_99: number;    // Gross profit (BR-C01)
  fc110_100: number;   // Gross profit rate % (BR-C02)
  fc110_90: number;    // Version
}

export interface QueryResponse {
  items: WriteoffItem[];
  total: number;
}

export interface ExecuteResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const c5m2Api = {
  /** Query S/C items within a range */
  async query(startNo: string, endNo: string): Promise<QueryResponse> {
    const res = await apiClient.post('/api/c5m2/query', {
      start_no: startNo,
      end_no: endNo,
    });
    return res.data;
  },

  /** Execute batch writeoff for selected S/C items */
  async execute(scNos: string[]): Promise<ExecuteResponse> {
    const res = await apiClient.post('/api/c5m2/execute', {
      sc_nos: scNos,
      confirmed: true,
    });
    return res.data;
  },
};
